import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { it } from './locales/it';
import { en } from './locales/en';
import { es } from './locales/es';
import { pt } from './locales/pt';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    lng: localStorage.getItem('language') || 'it',
    fallbackLng: 'it',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
